import { Controller } from "@hotwired/stimulus"

// This controller helps to preview a Image selected from a file input
export default class extends Controller {
  static targets = [ "input", "preview" ];
  static values = {
    autoOpen: Boolean // Triggers the input file to select a file on open
  };

  connect() {
    console.debug("File Field Controller connected, File Input: ", this.inputTarget,
        "Preview:", this.previewTarget, "Auto open: ", this.autoOpenValue);

    this.inputTarget.addEventListener('change', this.inputFileChanged);

    if (this.autoOpenValue) {
      this.inputTarget.click();
    }
  }

  disconnect() {
    this.inputTarget.removeEventListener('change', this.inputFileChanged);
  }

  inputFileChanged = (event) => {
    this.previewImage(event.target.files[0]);

    setTimeout(() => {
      this.element.scrollIntoView();
    });
  }

  previewImage(file) {
    console.debug("Previewing ", file, file.size, file.type);

    const reader = new FileReader();

    reader.onload = (e) => {
      this.previewTarget.src = e.target.result;
    }

    reader.readAsDataURL(file);
  }
}